import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useEffect, useState, useCallback, Fragment } from "react";

import api from "@/services/api";
import UsersView from "./UsersView";
import { asCaught } from "@/services/caughtError";

/** A row of GET /api/users/ as this screen reads it; UsersView renders the rest. */
type UserRow = { _id: string; name: string };

const UsersContainer = () => {
  const permission = useCurrentPermission();

  const [users, setUsers] = useState<UserRow[]>([]);
  const [usersSource, setUsersSource] = useState<UserRow[]>([]); // for search

  const fetchUsers = useCallback(async () => {
    try {
      const { data } = await api.get("/api/users/");
      setUsers(data.slice().reverse());
      setUsersSource(data);
    } catch (err) {
      console.error('[users] fetch failed', asCaught(err)?.response || err);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const deleteUserLocally = (userId: string) => {
    setUsers((prev) => prev.filter((u) => u._id !== userId));
  };

  const editRoleLocally = (updated: UserRow) => {
    setUsers((prev) => prev.map((u) => (u._id === updated._id ? updated : u)));
  };

  const onSearch = (value?: string) => {
    if (value?.length) {
      const q = value.toLowerCase();
      setUsers(usersSource.filter((u) => u.name.toLowerCase().includes(q)));
    } else {
      setUsers(usersSource);
    }
  };

  return (
    <Fragment>
      <UsersView
        total={users.length}
        users={users}
        permission={permission}
        onSearch={onSearch}
        onLocalDelete={deleteUserLocally}
        onLocalEditRole={editRoleLocally}
      />
    </Fragment>
  );
};

export default UsersContainer;
